import React from 'react';

const JunkOutlineIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Icon/Outline/junk-outline</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="#474747" fillRule="nonzero">
        <g>
          <path d="M3.55922701,5.20679664 L3.86894364,20.3246256 C3.89180096,21.4057767 4.79009349,22.2857834 5.87124455,22.2857834 L18.2564814,22.2857834 C19.3387753,22.2857834 20.2370678,21.4057767 20.2587823,20.3246256 L20.5684989,5.20679664 L22.2827976,5.20679664 L21.973081,20.3600545 C21.9319379,22.382927 20.2793538,24.0000821 18.2564814,24.0000821 L5.87124455,24.0000821 C3.84837206,24.0000821 2.19693096,22.382927 2.15578779,20.3600545 L1.84492829,5.20679664 L3.55922701,5.20679664 Z M16.061,7.5 L17.122,8.56100002 L13.372,12.311 L17.122,16.061 L16.061,17.121 L12.311,13.371 L8.561,17.121 L7.5,16.061 L11.25,12.311 L7.5,8.56100002 L8.561,7.5 L12.311,11.25 L16.061,7.5 Z M0.857149364,0 L23.1428506,0 C23.6171399,0 24,0.38286005 24,0.857149364 C24,1.33143868 23.6171399,1.71429872 23.1428506,1.71429872 L0.857149364,1.71429872 C0.38286005,1.71429872 0,1.33143868 0,0.857149364 C0,0.38286005 0.38286005,0 0.857149364,0 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default JunkOutlineIcon;